import React, { FC } from "react";

import { TableCell } from "@mui/material";

import { DateFormat, Status } from "@/components/atoms";
import { byteSizeFormatter } from "@/core/string";
import { Document } from "@/shared/domain";

import { StatusColorMap } from "../utils";
import { StyledDocumentsListMobileRow } from "./styled";

export type DocumentTableItemMobileProps = {
    document: Document;
    onClick: () => void;
};

const DocumentTableItemMobile: FC<DocumentTableItemMobileProps> = ({ document, onClick }) => {
    return (
        <StyledDocumentsListMobileRow
            key={`document-${document.id}`}
            data-testid={`document_item_mobile-row-${document.id}`}
            onClick={onClick}
        >
            <TableCell classes={{ root: "tablecell-root" }}>
                <div className="itemHeader">
                    <span className="date label highlightText">
                        <DateFormat date={document.date} />
                    </span>
                    <Status
                        className="highlightText"
                        text={document.status.name}
                        color={StatusColorMap[document.status.id]}
                        noBullet
                    />
                </div>
                <span className="documentTitle label highlightText">{document.description}</span>
                <span className="description label highlightText">{document.secondaryDescription}</span>
                <span className="size label highlightText">{`${document.documentType.name} - ${byteSizeFormatter(
                    document.fileSize,
                )}`}</span>
            </TableCell>
        </StyledDocumentsListMobileRow>
    );
};
export default DocumentTableItemMobile;
